// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages-RefundChargeGoogleForm-styles___header--cvC2v {
  margin-top: 64px;
}
`, "",{"version":3,"sources":["webpack://./pages/RefundChargeGoogleForm/styles.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB","sourcesContent":[".header {\n  margin-top: 64px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `pages-RefundChargeGoogleForm-styles___header--cvC2v`
};
module.exports = ___CSS_LOADER_EXPORT___;
